import { useQuery } from "react-query";
import {
  getExpenses,
  getExpenseAnalytics,
  getExpenseCategories,
  getExpenseDepartments,
  getExpenseDepartmentDetails,
} from "../../../services/expenses";

export const useGetExpenses = (queries = "") => {
  return useQuery(
    ["getExpenses", queries],
    () => getExpenses(queries).then((res) => res?.data),
    {
      enabled: queries !== null,
    },
  );
};

export const useGetExpensesAnalytics = (queries = "") => {
  return useQuery(
    ["getExpenseAnalytics", queries],
    () => getExpenseAnalytics(queries).then((res) => res?.data?.data),
    {
      enabled: queries !== null,
    },
  );
};

export const useGetExpenseCategories = (queries = "") => {
  return useQuery(["getExpenseCategories", queries], () =>
    getExpenseCategories(queries).then((res) => {
      // setMetaDetails(res.data?.meta);
      return res.data?.data;
    }),
  );
};

export const useGetExpenseDepartments = ({ queries = "" }) => {
  return useQuery(
    ["getExpenseDepartments", queries],
    () => getExpenseDepartments(queries).then((res) => res.data),
    { staleTime: Infinity },
  );
};

export const useGetExpenseDepartmentDetails = ({ id }) => {
  return useQuery(
    ["getExpenseDepartmentDetails", `${id}`],
    () => getExpenseDepartmentDetails({ id }).then((res) => res.data?.data),
    { staleTime: Infinity },
  );
};
